  <template >
  <div>
  <div>
  <div class="formPosition" style="width:1000px;margin:auto;margin-top:10px;">
    <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading  "></v-progress-linear>
     <v-card
    :loading="loading"
  >
    <v-card-title style="background-color:#006699;color:white;">Consultar</v-card-title>
     <v-alert
                v-model="alert"
                dismissible
                :type="alertType"
                border="left"
                :icon="iconAlert"
                transition="scale-transition"
                :style="colorAlert"
                elevation="2"
                colored-border
              >
              {{msgAlert}}
            </v-alert>
    <v-card-text>
      <v-row>
  
 <!-- ============================DIALOGOS DE VALORES DE MULTA ============================================ -->
<v-row justify="center">
    <v-dialog
      v-model="dialogV"
      persistent
      max-width="600px"
    >
   <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
      <v-card>
        <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
        <v-card-title style="background-color:#006699;color:white;">
          <span class="headline">Alterar o prazo de multa</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col  cols="12" md="12">
                      <v-combobox
                        v-model="tipoMultaSelected"
                        :rules="ruleRequired"
                        item-value="id"
                        item-text="descricao"
                        @change="SelectMulta()"
                        :items="tipoMulta"
                        chips
                        label="Tipo de Multa"
                      ></v-combobox>
                    </v-col>

                     <v-col  cols="12" md="4">
                      <v-text-field
                        v-if="!showFixos"
                        :rules="ruleNumber"
                        v-model="this.editedItemPreco.valor1"
                        :disabled="tipoMultaSelected === null"
                        label="Valor para o primeiro prazo"
                      ></v-text-field>

                      <v-text-field
                        v-if="showFixos"
                        v-money="money"
                        v-model="this.editedItemPreco.valor1"
                        :disabled="tipoMultaSelected === null"
                        label="Valor para o primeiro prazo"
                      ></v-text-field>
                    </v-col>

                     <v-col  cols="12" md="4">
                      <v-text-field
                        v-if="!showFixos"
                        :rules="ruleNumber"
                        v-model="this.editedItemPreco.valor2"
                        :disabled="tipoMultaSelected === null"
                        label="Valor para o segundo prazo"
                      ></v-text-field>

                      <v-text-field
                        v-if="showFixos"
                        v-money="money"
                        v-model="this.editedItemPreco.valor2"
                        :disabled="tipoMultaSelected === null"
                        label="Valor para o segundo prazo"
                      ></v-text-field>
                    </v-col>

                     <v-col  cols="12" md="4">
                      <v-text-field
                        v-if="!showFixos"
                        :rules="ruleNumber"
                        v-model="this.editedItemPreco.valor3"
                        :disabled="tipoMultaSelected === null"
                        label="Valor para o terceiro prazo1"
                      ></v-text-field>

                       <v-text-field
                        v-if="showFixos"
                        v-money="money"
                        v-model="this.editedItemPreco.valor3"
                        :disabled="tipoMultaSelected === null"
                        label="Valor para o terceiro prazo"
                      ></v-text-field>
                    </v-col>
                    <v-col md="6"></v-col>
                     <v-col md="5"></v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            style="color:white;"
            @click="dialogV = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green darken-1"
            style="color:white;"
            @click="AlterarPreco()"
          >
            Alterar
          </v-btn>
        </v-card-actions>
      </v-card>
   </v-form>
    </v-dialog>
  </v-row>
  <!-- ================================FM DO DIALOGO DE PRAZOS ===================================== -->
 
          <v-col md="12">
            <v-card
    :loading="loading"
  >
    <v-card-title>Valor de cobrança das Multas</v-card-title>

    <v-card-text>
      <v-row>
        <v-col md="4">
          <v-select
          :items="items"
          label="Selecione o curso"
        ></v-select>
        </v-col>
      </v-row>
       <v-data-table :headers="headersValor" :items="valoresMulta" :search="search">
        <template v-slot:item.action="{ item }">
              <v-btn color="green" icon @click="EditarPreco(item)"><v-icon>edit</v-icon></v-btn>
          </template>
       </v-data-table>
    </v-card-text>

  </v-card>
          </v-col>
      </v-row>
    </v-card-text>
  </v-card>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'
// const axios = require('../plugins/axios')
export default {
  directives: { mask, money: VMoney },
  data: () => ({
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    money: {
      decimal: ',',
      thousands: '.',
      suffix: ' Kz',
      precision: 2,
      masked: false
    },
    itemPrazo: null,
    datebi: null,
    date: null,
    descricao: 'Nº do Bi',
    contas: [],
    dialog: false,
    valid: true,
    prazosMulta: [],
    maxYear: '2025-12-31',
    minYear: '1950-01-01',
    valoresMulta: [],
    menuMulta1: false,
    dateMulta1: false,
    menuMulta2: false,
    dateMulta2: false,
    menuMulta3: false,
    dateMulta3: false,
    percentual1: 0,
    percentual2: 0,
    percentual3: 0,
    tipoMultaSelected: null,
    fixo1: 0,
    showFixos: false,
    fixo2: 0,
    fixo3: 0,
    overlay: false,
    dialogV: false,
    searchInDb: '',
    multas: [],
    servicos: [],
    idd: false, // simula autoinclemet
    alert: false,
    colorAlert: 'color:green;',
    iconAlert: 'done',
    alertType: 'success',
    msgAlert: '',
    tipoMulta:
    [
      { id: 1, descricao: 'Percentual' },
      { id: 2, descricao: 'Fixo' }
    ],

    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'Invalido.'
      }
    ],
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    headers: [
      { text: 'Mês', value: 'nome' },
      { text: 'Data Multa 1', value: 'p1' },
      { text: 'Data Multa 2', value: 'p2' },
      { text: 'Data Multa 3', value: 'p3' }
      // { text: 'Editar', value: 'action', sortable: false }

    ],
    headersValor: [
      { text: 'Curso', value: 'curso' },
      { text: 'Classe', value: 'classe' },
      { text: 'Tipo Multa', value: 'tipoMulta' },
      { text: 'V.1', value: 'valor1' },
      { text: 'V.2', value: 'valor2' },
      { text: 'V.3', value: 'valor3' },
      
      { text: 'Editar', value: 'action', sortable: false }

    ],

    msg: '',
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    editedItem:
    {
      autor: '',
      data1: '',
      data2: '',
      data3: '',
      nome_classe: '',
      nome_curso: '',
      nome_mes: '',
      percentagem1: '',
      percentagem2: '',
      percentagem3: '',
      valor_kwanza1: '',
      valor_kwanza2: '',
      valor_kwanza3: ''
    },
    editedItemPrazo: {
      nome: '',
      p1: '',
      p2: '',
      p3: '',
      pkPrazo: '',
      fkMes: ''
    },
    editedItemPreco: {
      classe: '',
      curso: '',
      fk_curso: 0,
      idanoacademico: 0,
      pk_classe: 0,
      tipoMulta: '0',
      valor1: 0,
      valor2: 0,
      valor3: 0
    }

  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    }

  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    menuMulta1 (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'MONTH'))
    },
    menuMulta2 (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menuMulta3 (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select

    this.initialize()
    this.initializeValores()
  },

  methods: {

    async initializeValores () {
      try {
        //   let  payload =""

        this.isLoading = true
        this.valoresMulta = await axios
          .get('/ValorMultaFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    retornaMes (mes){
      switch (mes) {
        case 1:
            return 'Janeiro';
         case 2:
            return 'Fevereiro';
           case 3:
            return 'Março';
             case 4:
            return 'Abril';
             case 5:
            return 'Maio';
             case 6:
            return 'Junho';
             case 7:
            return 'Julho';
             case 8:
            return 'Agosto';
             case 9:
            return 'Setembro';
             case 10:
            return 'Outubro';
             case 11:
            return 'Novembro';
           case 12:
            return 'Dezembro';
      }
    },

    async initialize () {
      try {
        //   let  payload =""

        this.isLoading = true
        this.prazosMulta = await axios
          .get('/prazoMultaFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // combo qua depende de outra combo

    async initializeServicos () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.servicos = await axios
          .get('/ServicosFindAll')
          .then(res => res.data)
        console.log(this.servicos)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    // END METHOD FOR VAL
    editItem (item) {
      // this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      console.log(this.editedItem)

      this.dialog = true
    },

    close () {
      this.dialog = false
      this.$refs.form.reset()
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    EditarPrazo (item) {
      this.editedItemPrazo = Object.assign(this.editedItemPrazo, item)
      console.log(item)
      this.dialog = true
    },
    saveDateMulta1 (dateMulta1) {
      this.$refs.menuMulta1.save(dateMulta1)
      this.editedItemPrazo.p1 = dateMulta1
      this.data1Bd = dateMulta1

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(dateMulta1).toISOString().substr(0, 10)
    },
    saveDateMulta2 (dateMulta2) {
      this.$refs.menuMulta2.save(dateMulta2)
      this.editedItemPrazo.p2 = dateMulta2
      this.data2Bd = dateMulta2
      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(dateMulta2).toISOString().substr(0, 10)
    },
    saveDateMulta3 (dateMulta3) {
      this.$refs.menuMulta3.save(dateMulta3)
      this.editedItemPrazo.p3 = dateMulta3
      this.data3Bd = dateMulta3
      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(dateMulta3).toISOString().substr(0, 10)
    },
    showAlertSucess (msg) {
      this.colorAlert = 'color:green;'
      this.iconAlert = 'done'
      this.alertType = 'success'
      this.msgAlert = msg
      this.alert = true
      setTimeout(() => {
        this.alert = false
      }, 2000)
    },
    showAlertError (msg) {
      this.colorAlert = 'color:red;'
      this.iconAlert = 'error'
      this.alertType = 'error'
      this.msgAlert = msg
      this.alert = true
      setTimeout(() => {
        this.alert = false
      }, 2000)
    },
    async AlterarPrazo () {
      if (this.$refs.form.validate()) {
        this.overlay = true
        let params = {
          mes: this.editedItemPrazo.nome,
          dataMulta1: this.editedItemPrazo.p1,
          dataMulta2: this.editedItemPrazo.p2,
          dataMulta3: this.editedItemPrazo.p3,
          idMes: this.editedItemPrazo.fkMes,
          pk_definir_multa: this.editedItemPrazo.pkPrazo
        }
        try {
        //   let  payload =""
          let result = await axios
            .post('/definirMultaInsertOrUpdate', params)
            .then(res => res.data)
          this.overlay = false
          if (result.affectedRows >= 1) {
            this.dialog = false
            this.showAlertSucess('Prazo de multa alterado com sucesso')
            this.this.initialize()
          } else {
            this.dialog = false
            this.showAlertError('Ocorreu um erro ao tentar executar a operação')
          }
        } catch (error) {
          this.dialog = false

          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },
    async  EditarPreco (item) {
      this.editedItemPreco = Object.assign(this.editedItemPreco, item)
      this.tipoMultaSelected = this.tipoMulta.filter(m => m.descricao === item.tipoMulta)[0]
      this.showFixos = (this.editedItemPreco.tipoMulta === 'Fixo')
      if (this.showFixos) {
        this.editedItemPreco.valor1 = utilitarios.IntegerToMoneyValue(this.editedItemPreco.valor1)
        this.editedItemPreco.valor2 = utilitarios.IntegerToMoneyValue(this.editedItemPreco.valor2)
        this.editedItemPreco.valor3 = utilitarios.IntegerToMoneyValue(this.editedItemPreco.valor3)
      }
      this.dialogV = true
      console.log(this.editedItemPreco.tipoMulta)
    },
    async  AlterarPreco () {
      if (this.$refs.form.validate()) {
        let params = {
          pk_definir_multa: 0,
          tipoMulta: this.tipoMultaSelected.descricao,
          fk_classe: this.classeSelected.pkAnoacademico,
          classe: this.classeSelected.descricao,
          pk_curso: this.cursoSelected.idCurso,
          percentual1: this.percentual1,
          percentual2: this.percentual2,
          percentual3: this.percentual3,
          valor1: utilitarios.MoneyValueToInteger(this.fixo1),
          valor2: utilitarios.MoneyValueToInteger(this.fixo2),
          valor3: utilitarios.MoneyValueToInteger(this.fixo3),
          aplicarClassesSemCurso: this.opcao1,
          aplicarClassesComurso: this.opcao2
        }
      }
    },
    SelectMulta () {
      if (this.tipoMultaSelected.id === 1) {
        this.showFixos = false
        this.Limpar()
      } else {
        this.showFixos = true
        this.Limpar()
      }
    }
  },
  Limpar () {
    this.editedItemPreco.valor1 = 0
    this.editedItemPreco.valor2 = 0
    this.editedItemPreco.valor3 = 0
  }
}
</script>
<style scoped>

.bg {
 color:green;
 background: red
}

</style>
